// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-btn {\n    margin-bottom: 8px;\n}\n\n.sku-preview .tag {\n    margin: 0 2px;\n}\n\n.sku-preview {\n    margin-bottom: 8px;\n}\n\n.clear-all {\n    margin-bottom: 12px;\n}\n\n.clear-all:hover {\n    cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
